import React from 'react'
// Import CommonBanner Area
import CommonBanner from '../component/Common/CommonBanner'
// import MakeDonationArea
import MakeDonationArea from '../component/MakeDonation'


const MakeDonationPage = () => {
  return (
    <>
      <CommonBanner heading="Support PCF" pagination="Support PCF"/>
      <MakeDonationArea/>
    </>
  )
}

export default MakeDonationPage